const custom = require('../../node_modules/@awesome.me/kit-cd53c7081b/icons/js/custom-icons.js');
const brands = require('../../node_modules/@awesome.me/kit-cd53c7081b/icons/js/brands.js');
const regular = require('../../node_modules/@awesome.me/kit-cd53c7081b/icons/js/sharp-regular.js');
const solid = require('../../node_modules/@awesome.me/kit-cd53c7081b/icons/js/sharp-solid.js');
const fontawesome = require('../../node_modules/@awesome.me/kit-cd53c7081b/icons/js/fontawesome.js');



